import React from 'react';

export interface IToggleProps {
  isOpen: boolean;
  setOpen: () => void;
  setClosed: () => void;
  toggle: () => void;
}

interface IProps {
  startOpen?: boolean; // Undefined will be treated as false or closed.
  children(props: IToggleProps): React.ReactNode;
}

interface IState {
  isOpen: boolean;
}

/**
 * Generic component that keeps track of a state that can toggle between
 * open and closed.
 */
export class ToggleState extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: !!props.startOpen,
    };
  }

  public render() {
    const renderProps = {
      isOpen: this.state.isOpen,
      setOpen: this.setOpen,
      setClosed: this.setClosed,
      toggle: this.toggle,
    };

    return this.props.children(renderProps);
  }

  private setOpen = () => {
    this.setState({ isOpen: true });
  };

  private setClosed = () => {
    this.setState({ isOpen: false });
  };

  private toggle = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };
}

export default ToggleState;
